import {
  LanguageListActionTypes,
  LANGUAGE_LIST_FAIL,
  LANGUAGE_LIST_LOADING,
  LANGUAGE_LIST_SUCCESS,
  LanguageListState,
  LANGUAGE_LIST_API_MSG,
  LANGUAGE_LIST_API_RES,
} from "./ActionTypes";
import { LanguageListResponse } from "./Model";

const initialStateEditPosts: LanguageListState = {
  loading: false,
  languageListResponse: {} as LanguageListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const LanguageListReducer = (
  state = initialStateEditPosts,
  action: LanguageListActionTypes
): LanguageListState => {
  switch (action.type) {
    case LANGUAGE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case LANGUAGE_LIST_SUCCESS:
      return {
        ...state,
        languageListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case LANGUAGE_LIST_FAIL:
      return {
        ...state,
        languageListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case LANGUAGE_LIST_API_MSG:
      return {
        ...state,
        languageListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case LANGUAGE_LIST_API_RES:
      return {
        ...state,
        languageListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
